var _polyline, _polyline2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMaximize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  points: "15 3 21 3 21 9"
})), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
  points: "9 21 3 21 3 15"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 21,
  x2: 14,
  y1: 3,
  y2: 10
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 3,
  x2: 10,
  y1: 21,
  y2: 14
})));
export default SvgMaximize;